var exports = {
  "k": "xa15a2ab7--7f0ce2--container",
};

module.exports = exports;
